import "core-js/modules/es.date.to-string.js";
import { format, subDays } from "date-fns";
/**
 * Formats a date string from a certain format to 'dd/MM/yyyy' format.
 * @param {string} date - The input date string.
 * @returns {string} The formatted date string in 'dd/MM/yyyy' format.
 */
export var formatDateToddMMYYYY = function formatDateToddMMYYYY(date) {
  // Create a Date object from the input date string
  if (typeof date === "string") {
    var dateFromString = new Date(date);
    // Check if the created Date object is valid
    if (isNaN(dateFromString.valueOf())) return ""; // Return an empty string if the date is invalid
    // Construct the formatted date string with the "dd/MM/yyyy" format
    return format(dateFromString, "dd/MM/yyyy");
  }
  return format(date, "dd/MM/yyyy");
};
/**
 * Subtracts a specified number of days from a given date.
 * If no initial date is provided, the current date is used as the default.
 * If the number of days is less than zero, it defaults to 0.
 * @param {Date} initialDate - The initial date to subtract days from (default: current date).
 * @param {number} days - The number of days to subtract.
 * @returns {Date} A new Date object representing the result of subtracting the specified days from the initial date.
 */
export var subtractDaysFromDate = function subtractDaysFromDate() {
  var initialDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  var days = arguments.length > 1 ? arguments[1] : undefined;
  // fallback in case days is less than zero
  if (days < 0) {
    days = 0;
  }
  // Subtract the specified number of days from the initial date and return the resulting date
  return subDays(initialDate, days);
};